import {getLayoutDefaultValue,getStyleDefaultValue} from '../../../utils/configuration/defaultSchema/schema.util'
import {COMPONENT_SCHEMA,EVENTS_SCHEMA} from '../../../utils/configuration/schema';

export const dialogDefaultSchema = (data) => {
    const {componentName,componentId} = data; return {
        component: {
            [COMPONENT_SCHEMA.ID]: `${componentName}${componentId !== '' ? '_' : ''}${componentId}`,
            [COMPONENT_SCHEMA.SHOW]: 'true',
            
        },
        style: getStyleDefaultValue(data),
        layout: getLayoutDefaultValue(data),
        events: [
            EVENTS_SCHEMA.ON_OPEN,
            EVENTS_SCHEMA.ON_CLOSE
        ]
    }
}